import { render, staticRenderFns } from "./AddressInfoComponent.vue?vue&type=template&id=b3c24e58&scoped=true&"
import script from "./AddressInfoComponent.vue?vue&type=script&lang=js&"
export * from "./AddressInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddressInfoComponent.vue?vue&type=style&index=0&id=b3c24e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c24e58",
  null
  
)

component.options.__file = "AddressInfoComponent.vue"
export default component.exports